<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10" style="margin-top:16px">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <el-table-column type="index" label="序号" align="center" width="70" />
            <template v-for="(item1, i) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field !='id'" :key="i" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div :class="scope.row[i]?'operation-btn':'pointer-e'" v-if="item1.field == 'jobReq'" @click.stop="goJobReq(scope.row[i])">详情</div>
                  <span v-else class="textOverflow">{{ columnValue(scope.row[i], item.moduleId)}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="handleCurrentChange2" />
        </div>
      </title-block>
    </template>
    <jobReqDetail ref="jobReqDetail"></jobReqDetail>
  </div>
</template>

<script>
import overflowTooltip from '@/views/clue/components/overflowTooltip'
import mixin from '../mixins/enterpriseTabs'
import jobReqDetail from '../dialog/jobReqDetail'
export default {
  mixins: [mixin],
  name: 'recruitmentMsg',
  components: {
    overflowTooltip,
    jobReqDetail
  },
  props: {
    tabsInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      titles: [
        // { type: '', label: '招聘信息统计分析', num: 0, moduleId: '', pageNum: 1 },
        { type: '', label: '招聘详情', num: 1, moduleId: '409', pageNum: 1 },
      ],
      info: {},
      brief: '',
      briefAll: '',
      showMoreText: false,
      same: [],
      pageNum: 1,
      sameTotal: 0,
    }
  },
  inject: ['$companyStatus'],

  mounted() {
    this.titles = this.tabsInfo
  },
  methods: {
    goJobReq(row) {
      this.$refs.jobReqDetail.showDialog(row)
    },
    handleCurrentChange2(val) {
      this.$emit('pageTurn', val) // index 是 titles 的下标
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-table__empty-block {
    width: 100% !important;
  }
}
.brief {
  font-size: 12px;
  padding: 10px;
  padding-top: 16px;
  .showMoreText {
    font-size: 12px;
    color: #4f7afd;
    line-height: 22px;
    cursor: pointer;
  }
}
.table {
  border: 1px solid #e1e7ed;
  font-size: 12px;
  .el-row + .el-row {
    border-top: 1px solid #e1e7ed;
  }
  .el-row {
    display: flex;
    .el-col {
      font-size: 12px;

      padding: 10px;
      color: #666666;
      display: inline-flex;
      align-items: center;
    }
    .el-col-5 {
      background: #fafafa;
      color: rgba(52, 57, 81, 0.8);
      width: 137px;
    }
    .el-col + .el-col {
      border-left: 1px solid #e1e7ed;
    }
  }
}
/deep/ .el-table th > .cell {
  font-size: 13px;
  font-weight: 400;
  font-weight: bold;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}

.tables /deep/ .el-table__header {
  width: 100% !important;
}
.tables /deep/ .el-table__body {
  width: 100% !important;
}

.holderInfo {
  .infoWrap {
    display: flex;
    flex-wrap: wrap;
    .basicInfo {
      width: 313px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #f1f1f2;
      // padding: 16px;
      margin: 0 8px 8px 0;
      margin-right: 16px;
      padding-bottom: 16px;
      > p {
        font-size: 12px;
        color: #666;
        line-height: 12px;
        margin: 0 0 8px;
        &:first-child {
          color: #333;
        }
        &:last-child {
          margin-bottom: 0;
        }
        display: flex;
        span:first-child {
          flex-grow: 0;
          flex-shrink: 0;
        }
        span {
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 12px;
        }
      }
      p:first-child {
        background: #f7f7fa;
        height: 50px;
        line-height: 50px !important;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        /deep/ span {
          text-align: left !important;
        }
      }
      &:nth-of-type(2n) {
        margin-right: 0;
      }
    }
  }
}
.operation-btn {
  color: #5088ff;
  cursor: pointer;
}
.pointer-e {
  pointer-events: none;
  color: rgba(51, 51, 51, 0.5);
}
</style>
